"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedSpecies = exports.getDefaultView = exports.getAnatomogramViews = void 0;

var _svgsMetadata = _interopRequireDefault(require("./json/svgsMetadata.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var unique = function unique(element, index, array) {
  return array.indexOf(element) === index;
};

var isNotBlank = function isNotBlank(str) {
  return typeof str === "string" && str.trim() !== "";
};

var supportedSpecies = _svgsMetadata["default"].map(function (svgMetadata) {
  return svgMetadata.species;
}).filter(unique);

exports.supportedSpecies = supportedSpecies;

var multipleViewsSpecies = _svgsMetadata["default"].filter(function (svgMetadata) {
  return svgMetadata.view !== "";
}).map(function (svgMetadata) {
  return svgMetadata.species;
}).filter(unique);

var anatomogramViews = multipleViewsSpecies.reduce(function (acc, species) {
  acc[species] = _svgsMetadata["default"].filter(function (svgMetadata) {
    return svgMetadata.species === species;
  }).map(function (svgMetadata) {
    return svgMetadata.view;
  }).filter(isNotBlank).sort().reverse(); // The order we want is `male`, `female`, `brain` and `whole_plant`, `flower_parts` :)

  return acc;
}, {});

var getAnatomogramViews = function getAnatomogramViews(species) {
  if (supportedSpecies.includes(species)) {
    return anatomogramViews[species] || [];
  }
};

exports.getAnatomogramViews = getAnatomogramViews;

var getDefaultView = function getDefaultView(species) {
  if (supportedSpecies.includes(species)) {
    return getAnatomogramViews(species)[0] || null;
  }
};

exports.getDefaultView = getDefaultView;